import React from "react";
import { landingStyles } from "components/Landing/landingStyles";
import HeroBanner from "components/Marketing/Components/HeroBanner";
import Footer from "components/Footer";
import FeatureGrid from "./FeatureGrid";
import SiteGrid from "./SiteGrid";
import { BUTTON_TAGS } from "utils/constants/ui";
import LogoConnection from "components/LogoConnection";
import { cellGrow } from "constants/styles";
import PATHS from "utils/paths";
import Link from "next/link";
import { YOUTUBE_VIDEO_ID } from "utils/constants/video";
import VideoPreview from "components/VideoPreview";

const VIDEO_PROPS = {
  header: "See how easy it is!",
  body: `Watch how easy it is to add payments to any Webflow site 🚀`,
  videoId: YOUTUBE_VIDEO_ID.INTEGRATIONS_WEBFLOW
};

const MarketingIntegrationsWebflow = () => {
  const heroProps = {
    header: [
      {
        copy: "One click payments."
      },
      {
        classes: "color-primary underline",
        copy: "No coding"
      },
      {
        copy: "required."
      }
    ],
    action: {
      tag: BUTTON_TAGS.LINK,
      href: PATHS.SIGNUP,
      copy: "Signup",
      classes: {
        button:
          "fw6 br2 pa3 border-box input-reset ba bg-transparent pointer f4 dib link items-center flex flex-shrink-0 cell-grow"
      }
    },
    paddingBottom: 20,
    bgImage: "hero_bg_integrations_webflow",
    subheader:
      "Accept one time and recurring payments from any Webflow page, in one click."
  };

  return (
    <div className="w-100 relative">
      <div className="mw8 center">
        <HeroBanner {...heroProps} />
        <div className="pb3">
          <Link href={PATHS.SIGNUP}>
            <div className="pointer cell-grow">
              <LogoConnection src="/assets/priceblocs_webflowConnect.png" />
            </div>
          </Link>
        </div>
        <div className="pa3 pb5">
          <FeatureGrid />
        </div>
        <div className="items-center flex justify-center pb5">
          <VideoPreview {...VIDEO_PROPS} />
        </div>
        <div className="pg3 pb5">
          <SiteGrid />
        </div>
        <div className="pt5 hairline-1 bt">
          <Footer />
        </div>
      </div>
      <style jsx>{landingStyles}</style>
      <style jsx>{cellGrow}</style>
    </div>
  );
};

export default MarketingIntegrationsWebflow;
